import { COMPARED_ECG_DURATION } from '../constants';

const getIntSamples = (samples: number[], initialIndex = 0, sampleRate = 512) => {
  const endIndex = initialIndex + COMPARED_ECG_DURATION * sampleRate;

  return samples.slice(initialIndex, endIndex).map(Math.floor);
};

export { getIntSamples };
